<script setup>
import * as fancybox from '@fancyapps/ui';
import "@fancyapps/ui/dist/fancybox.css";
const { Fancybox } = fancybox;

const props = defineProps({
  video: Object,
  album: Object
});

onMounted(() => {
  Fancybox.bind("[data-fancybox='gallery']", {
    Image: {
      zoom: false,
      wheel: "slide",
      hideScrollbar: false,
    },
  });
});
</script>

<template>
  <div class="flex flex-col space-y-7 pt-3 relative" v-if="album || video">
    <div class="w-full text-left mb-6">
      <h4 class="text-xl font-sans text-dark-gray">Фото и видео</h4>
      <h6 class="font-sans font-base text-primary"></h6>
    </div>
    <div class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-7">
      <div v-if="video"
        class="rounded-lg overflow-hidden relative xl:col-start-1 xl:col-end-3 xl:row-start-1 xl:row-end-3 aspect-w-4 aspect-h-3">
        <iframe :src="`https://www.youtube.com/embed/${video.link.split('/')[video.link.split('/').length - 1]
        }`" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen class="w-full h-full" />
      </div>
      <template v-if="album">
        <div v-for="(photo, index) in album.photos" :key="photo.fileKey"
          class="rounded-lg overflow-hidden aspect-w-4 aspect-h-3 flex" :class="[
            index === 0 && !video
              ? 'xl:col-start-1 xl:col-end-3 xl:row-start-1 xl:row-end-3'
              : ''
          ]">
          <img data-fancybox="gallery" :href="`https://ucarecdn.com/${photo.fileKey}/img.png`"
            class="object-cover w-full h-full cursor-pointer" loading="lazy"
            :src="`https://ucarecdn.com/${photo.fileKey}/-/format/auto/-/quality/smart/image.png`" />
        </div>
      </template>
    </div>
  </div>
</template>
